import React from 'react'

import { css, cx } from '@linaria/core'
import { styled } from '@linaria/react'

import { breakpoints } from 'components/designSystem/shared/breakpoints'
import { ContainerSize } from 'components/designSystem/shared/containerSize'
import { useHasUserRestrictions } from 'functions/hasUserRestrictions'
import { useAuthorized } from 'hooks/useAuthorized'
import { useNavigationSettings } from 'hooks/useNavigationSettings'

import { FooterPortal } from './FooterPortal'
import { useRemoveVisualEffectForPath } from './hooks/useRemoveVisualEffectForPath'
import { TabBar } from './TabBar'
import { StickyObserver } from '../StickyObserver/StickyObserver'

/**
 * При прокрутке появляется border у footer
 * Но так как некоторые мобильные браузеры обладают bounce scroll overflow
 * То данная конструкция работает обе стороны. Поэтому там где нет скролла(профиль и рейтинг)
 * Отключаем через useRemoveVisualEffectForPath
 */
export const Footer = () => {
  const userHasRestrictions = useHasUserRestrictions()
  const authorized = useAuthorized()
  const hasRemove = useRemoveVisualEffectForPath()
  const { isSearchSettingsPath, isRatingSettingsPath } = useNavigationSettings()

  if (userHasRestrictions) {
    return null
  }

  if (isSearchSettingsPath || isRatingSettingsPath) {
    return (
      <Parent className={filtersFooter} position="bottom">
        <FooterPortal />
      </Parent>
    )
  }

  return (
    <Parent
      className={cx(
        !authorized && mobileNotAuthorizedParentCss,
        hasRemove && emptyBackgroundCss
      )}
      position="bottom"
    >
      <Body isMobileBar={true} data-name="tab-bar-mobile" />
    </Parent>
  )
}

const Parent = styled(StickyObserver)`
  display: none;
  justify-content: center;
  align-items: center;
  position: sticky;
  bottom: 0;
  height: calc(var(--spacing-48px) * 2);
  min-width: 100%;
  background: var(--gradient-top-vertical);

  @media (max-width: ${breakpoints.startDesktop - 1}px) {
    display: flex;
  }

  @media (max-width: ${breakpoints.mobile}px) {
    min-width: 100%;
    height: var(--spacing-48px);
  }
`

const filtersFooter = css`
  height: auto;

  @media screen and (min-width: ${breakpoints.mobile + 1}px) {
    display: none;
  }
`

const emptyBackgroundCss = css`
  background: none;
`

const Body = styled(TabBar)`
  position: relative;
  flex-basis: 100%;

  @media screen and (max-width: ${breakpoints.middleDesktop - 1}px) {
    flex-basis: ${ContainerSize.tablet}px;
  }
`

const mobileNotAuthorizedParentCss = css`
  @media (max-width: ${breakpoints.mobile}px) {
    padding: var(--spacing-12px);
    height: auto;
  }
`
